'use client'

import { formatters } from '@morpho-org/ui-v6/utils'
import { ArrowDiagonalUp } from '@repo/ui/icons'

import type { VaultV2Risk } from '@/lib/procedures/vaultV2Risk.contract'

import { ButtonLink } from '@/components/common/ButtonLink'
import { RiskCuratorCard } from '@/components/common/RiskCuratorCard'
import { VAULTS_V2_DOCS_URL } from '@/config/external-urls'
import { formatTimestampToDate } from '@/helpers/date'

import { VaultV2RowList, VaultV2RowListRow } from '../../components/VaultV2RowList'

const formatter = formatters.short.digits(2).unit('$').default('-')

interface VaultConfigurationClientProps {
  creationTimestamp: VaultV2Risk['creationTimestamp']
  curators: VaultV2Risk['curators']
}

const VaultConfigurationClient = ({
  creationTimestamp,
  curators
}: VaultConfigurationClientProps) => {
  return (
    <VaultV2RowList>
      <VaultV2RowListRow label="Morpho vault version">
        <div className="gap-2xs flex items-center">
          <span className="text-foreground text-xs">v2</span>
          <ButtonLink
            href={VAULTS_V2_DOCS_URL}
            buttonProps={{
              variant: 'ghost',
              size: 'sm',
              iconRight: undefined,
              iconAlone: <ArrowDiagonalUp />,
              iconAloneProps: {
                className: 'text-secondary-foreground'
              }
            }}
          />
        </div>
      </VaultV2RowListRow>
      <VaultV2RowListRow label="Vault deployment date">
        <span className="text-foreground text-xs">
          {creationTimestamp == null ? '-' : formatTimestampToDate(creationTimestamp)}
        </span>
      </VaultV2RowListRow>
      {curators.map(curator => {
        const aum = curator.aumUsd ?? undefined
        const formattedAum = formatter.of(aum)
        return (
          <VaultV2RowListRow key={curator.id} label="Curator TVL">
            <RiskCuratorCard
              curator={{
                id: curator.id,
                name: curator.name,
                image: curator.image,
                state: aum != null ? { aum } : null
              }}
              chainId={null}
            >
              <span className="text-foreground text-xs" style={{ cursor: 'pointer' }}>
                {formattedAum}
              </span>
            </RiskCuratorCard>
          </VaultV2RowListRow>
        )
      })}
    </VaultV2RowList>
  )
}

export default VaultConfigurationClient
